module.exports = __webpack_public_path__ + "img/we-got-a-problem-dark.041f9c8d.svg";